<template>
  <div>
    <a
      v-if="previewImages.length"
      href="#"
      @click.prevent="galleryOpen = true"
    >{{ $t('models_and_train_configs.view_images') }}</a>
    <div v-for="file in metaFiles" :key="file.path">
      <a
        v-if="file.previewable"
        href="#"
        @click.prevent="openPreview(file)"
      >{{ file.name }}</a>
      <a v-else target="_blank" :href="file.path">{{ file.name }}</a>
    </div>
    <model-file-preview-modal
      v-if="previewFile"
      :file="previewFile"
      @close_modal="previewFile = null"
    ></model-file-preview-modal>
    <model-image-gallery
      v-if="galleryOpen"
      :images="previewImages"
      @close="galleryOpen = false"
    ></model-image-gallery>
  </div>
</template>

<script>
import ModelFilePreviewModal from '@/components/models/ModelFilePreviewModal';
import ModelImageGallery from '@/components/models/ModelImageGallery';
import { buildModelFiles } from '@/utils/modelFiles';

export default {
  name: "ModelMeta",
  components: { ModelFilePreviewModal, ModelImageGallery },
  props: {
    'model': {required: true}
  },
  data() {
    return {
      previewFile: null,
      galleryOpen: false,
    };
  },
  methods: {
    openPreview(file) {
      this.previewFile = file;
    },
  },
  computed: {
    parsedFiles() {
      const projectId = this.$store.getters['user/get_current_project_id'];
      const token = localStorage.token;
      return buildModelFiles(this.model, projectId, token);
    },
    previewImages() {
      return this.parsedFiles.previewImages;
    },
    metaFiles() {
      return this.parsedFiles.metaFiles;
    },
  },
}
</script>

<style scoped>

</style>
